import React, {useState} from "react"

const AnnualIncome = ({incomeData}) => {

    const [showPercent, setShowPercent] = useState(false)

    const total_income = Object.values(incomeData).reduce((acc, currentValue) => acc + Number(currentValue), 0)
    return <div style={{
        border: "1px solid lightgrey",
        borderRadius: "10px",
        marginTop: 10,
        width: "30%",
        margin: 20,
        position: "relative"
    }}>
        <div className="clickable"
             onClick={() => setShowPercent(!showPercent)}
             style={{
                 position: "absolute",
                 top: 15,
                 right: 10,
                 border: "1px solid grey",
                 borderRadius: "5px",
                 padding: "0 5px"
             }}>
            {showPercent ? "0.0" : "%"}
        </div>
        <p style={{marginLeft: 20, marginBottom: 0}}><b>CA par formule</b></p>
        <div style={{margin: 20, fontSize: 18}}>
            {Object.entries(incomeData)?.map((category, index) => {
                return <div key={index} style={{display: "flex", justifyContent: "space-between", gap: 20}}>
                    <div>{category[0].length ? category[0] : "Customisé"}:</div>
                    <div style={{display: "flex", gap: 5}}>
                        <div>{showPercent ?
                            `${(category[1] / total_income * 100).toFixed(2)}%` :
                            `${category[1]}€`}
                        </div>
                    </div>
                </div>
            })}
        </div>
    </div>
}

export default AnnualIncome